import React from 'react'
import { useSelector } from 'react-redux'
import TerraceBanner from './TerraceBanner'
import TerraceProduct from './TerraceProduct'
import MurPlaquePlatreProduct from './MurPlaquePlatreProduct'
import SolProduct from './SolProduct'
import BardageProduct from './BardageProduct'

const Terrace = ({ quoteData }) => {
  // Détecter le type de projet
  const projectType = useSelector(state => state.selectedProducts.projectType);
  const selectedProject = useSelector(state => state.selectedProject.selectedProject);
  const detectedProjectType = projectType || selectedProject?.project_type;

  return (
    <div>
      <TerraceBanner />
      {detectedProjectType === 'MUR_PLAQUE_PLATRE' ? (
        <MurPlaquePlatreProduct quoteData={quoteData} />
      ) : detectedProjectType === 'SOL' ? (
        <SolProduct quoteData={quoteData} />
      ) : detectedProjectType === 'BARDAGE' ? (
        <BardageProduct quoteData={quoteData} />
      ) : (
        <TerraceProduct quoteData={quoteData} />
      )}
    </div>
  )
}

export default Terrace